import { Outlet } from 'react-router-dom';


const LoggedInPageContainer = () => {
  return <Outlet />;
};

export default LoggedInPageContainer;